<template>
  <div v-if="isMainForm" class="pdf-order-section">
    <template v-if="orderStore.multiOrder.editMultiOrderMode && !orderStore.multiOrder.locked">
      <vz-multi-order-direction />
      <div v-if="isDispatchAddress" class="vz-personal-order-blocks">
        <vz-special-requirement
          v-if="isDispatchAddress"
          title-card="Забор груза"
          class="w-100"
        />
      </div>
    </template>
    <template v-else>
      <div>
        <div class="vz-individual-order-directions-title text-h1 mb-20 flex flex-space-between flex-align-items-center">
          <span>Отправление</span>
          <vz-button
            outline
            :title="orderStore.multiOrder.locked ? 'Заказ уже оформлен' : ''"
            :disabled="orderStore.multiOrder.locked"
            @click="orderStore.multiOrder.editMultiOrderMode = true"
          >
            Редактировать
          </vz-button>
        </div>
        <div class="vz-order-view-blocks">
          <vz-direction-view :order="orderStore.orderForm" />
          <vz-customer-view
            type="dispatch"
            hide-payer
            :order="orderStore.orderForm"
          />
        </div>
      </div>
      <vz-requirements-view
        ref="requirements"
        v-show="showRequirements"
        :order="orderStore.orderForm"
      />
    </template>
    <vz-multi-order-request-list />
  </div>

  <div v-else class="vz-multi-order-request-form">
    <template v-if="isNetworkRequest">
      <vz-network-direction class="vz-personal-order-blocks tiny-gap vz-multi-order-request-form-direction" />
      <vz-network-order-special-requirements-block />
      <vz-network-cargo-block />
      <vz-order-additional-block hide-disassemble />
      <vz-network-order-payer-block />
      <vz-order-members-block v-if="isPayerThird" hide-dispatch hide-destination />
    </template>
    <template v-else>
      <div class="vz-personal-order-blocks tiny-gap vz-multi-order-request-form-direction">
        <vz-destination-direction />
      </div>
      <vz-special-requirement
        v-if="isDestinationAddress"
        title-card="Отвоз груза"
        direction-to
        class="vz-multi-order-request-form-special-requirement"
      />
      <vz-individual-cargo-block />
      <vz-order-additional-block />
      <vz-individual-order-payer-block />
      <vz-order-members-block hide-dispatch />
    </template>
  </div>
</template>

<script setup lang="ts">
import VzMultiOrderDirection from '~/components/personal/order/multi-order/vz-multi-order-direction.vue';
import VzSpecialRequirement from '~/components/personal/order/special-requirements/vz-special-requirement.vue';
import {useOrderStore} from '~/stores/order';
import VzMultiOrderRequestList from '~/components/personal/order/multi-order/vz-multi-order-request-list.vue';
import VzDestinationDirection from '~/components/personal/order/direction/vz-destination-direction.vue';
import VzIndividualCargoBlock from '~/components/personal/order/cargo/vz-individual-cargo-block.vue';
import VzOrderAdditionalBlock from '~/components/personal/order/vz-order-additional-block.vue';
import VzIndividualOrderPayerBlock from '~/components/personal/order/payer/vz-individual-order-payer-block.vue';
import VzOrderMembersBlock from '~/components/personal/order/members/vz-order-members-block.vue';
import VzDirectionView from '~/components/personal/order/vz-order-view/direction/vz-direction-view.vue';
import VzButton from '~/components/ui-kit/vz-button.vue';
import VzCustomerView from '~/components/personal/order/vz-order-view/customer/vz-customer-view.vue';
import VzRequirementsView from '~/components/personal/order/vz-order-view/requirements/vz-requirements-view.vue';
import VzNetworkCargoBlock from '~/components/personal/order/cargo/vz-network-cargo-block.vue';
import VzNetworkOrderSpecialRequirementsBlock
  from '~/components/personal/order/special-requirements/vz-network-order-special-requirements-block.vue';
import VzNetworkOrderPayerBlock from '~/components/personal/order/payer/vz-network-order-payer-block.vue';
import VzNetworkDirection from '~/components/personal/order/direction/vz-network-direction.vue';

const orderStore = useOrderStore()
const requirements = ref<{visible: boolean, list: any}>()

const isMainForm = computed(() => {
  return orderStore.multiOrder.selectedRequestId === 0
})

const isNetworkRequest = computed(() => {
  return !isMainForm.value && orderStore.multiOrder.selectedRequest.meta.type === 'networking'
})

const isDispatchAddress = computed(() => {
  return orderStore.orderForm.directions.dispatch.direction === 'address'
})

const isDestinationAddress = computed(() => {
  return orderStore.orderForm.directions.destination.direction === 'address'
})

const showRequirements = computed(() => {
  return isDestinationAddress.value && requirements.value?.visible
})

const isPayerThird = computed((): boolean => {
  return orderStore.orderForm.customer.payer === 'third'
})
</script>

<style lang="scss" scoped>
.vz-multi-order-request-form {
  &-direction {
    :deep(> div:last-child) {
      margin-top: 35px;
    }
  }

  &-special-requirement {
    :deep(.vz-special-requirement-card-list) {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 36px;

      > hr {
        display: none;
      }

      @media screen and (max-width: 1300px) {
        gap: 12px;
      }
    }
  }
}
</style>
